/* Portfolio data — restructured for products / case studies / enterprise grouping */

export const products = [
  {
    name: "Primera Sección",
    labels: ["live"],
    tagline: "News portal for Argentine public-interest journalism. Fast, clean and built for independent media.",
    problem: "An independent media outlet needed a scalable, low-maintenance platform to publish and distribute content at pace.",
    stack: ["Next.js", "Node.js", "Docker", "Cloud Run", "Cloud Scheduler"],
    screenshot: "/mockups/primera seccion.webp",
    url: "primeraseccion.com",
    links: [
      { label: "primeraseccion.com", href: "https://www.primeraseccion.com/", kind: "live" }
    ],
  },
  {
    name: "Formulario Online",
    labels: ["live"],
    tagline: "Online form builder for Argentine businesses and professionals. Create, publish and collect data without writing code.",
    problem: "Businesses needed a reliable way to collect structured data online without depending on developers for every form change.",
    stack: ["React", "Node.js", "PostgreSQL", "Vercel"],
    screenshot: "/mockups/formulario online.webp",
    url: "formularioonline.com.ar",
    links: [
      { label: "formularioonline.com.ar", href: "https://www.formularioonline.com.ar/", kind: "live" }
    ],
  },
  {
    name: "Estudio Jurídico Baiud",
    labels: ["live"],
    tagline: "Modern digital presence for a Buenos Aires law firm. Trustworthy, mobile-first and SEO-ready.",
    problem: "The firm needed a professional web presence to attract clients and establish credibility in a competitive market.",
    stack: ["React", "Next.js", "CSS"],
    screenshot: "/mockups/estudio juridico baiud.webp",
    url: "estudiolcb.com.ar",
    links: [
      { label: "estudiolcb.com.ar", href: "https://www.estudiolcb.com.ar/", kind: "live" }
    ],
  },
  {
    name: "Estudio Jurídico Alabi",
    labels: ["live"],
    tagline: "Professional portfolio site for independent lawyer Miguel Alabi. Clean, fast and conversion-focused.",
    problem: "An independent lawyer needed a digital presence to build authority and attract new clients online.",
    stack: ["React", "Next.js", "CSS"],
    screenshot: "/mockups/estudio juridico alabi.webp",
    url: "miguelalabi.com",
    links: [
      { label: "miguelalabi.com", href: "https://www.miguelalabi.com/", kind: "live" }
    ],
  },
  {
    name: "Como Voto",
    labels: ["public"],
    tagline: "Guess how Argentine congressional representatives voted on real bills — built on scraped public voting records.",
    problem: "Congressional voting data is public but practically inaccessible. This game makes it tangible and engaging.",
    stack: ["React", "Node.js", "Cheerio", "Prisma", "PostgreSQL", "Vercel"],
    screenshot: "/mockups/como voto.webp",
    url: "scrapping-games.vercel.app/como-voto",
    links: [
      { label: "Play", href: "https://scrapping-games.vercel.app/como-voto", kind: "live" },
      { label: "GitHub", href: "https://github.com/RGabrielR/scrapping-games", kind: "github" }
    ],
  },
  {
    name: "Cuánto Sale",
    labels: ["public"],
    tagline: "Guess the rental price of real Argentine properties scraped from listings. Market data as an interactive game.",
    problem: "Real estate pricing is opaque and overwhelming. This experiment turns raw listing data into something fun to explore.",
    stack: ["React", "Node.js", "Puppeteer", "Prisma", "Vercel"],
    screenshot: "/mockups/cuanto esta.webp",
    url: "scrapping-games.vercel.app/cuanto-esta",
    links: [
      { label: "Play", href: "https://scrapping-games.vercel.app/cuanto-esta", kind: "live" },
      { label: "GitHub", href: "https://github.com/RGabrielR/scrapping-games", kind: "github" }
    ],
  },
];

export const caseStudies = [
  {
    name: "Order Management System",
    labels: ["case-study", "arch", "oss"],
    tagline: "Production-style OMS with inventory reservations, order lifecycle management and idempotent retries.",
    highlights: [
      "Stock reservation model with stockAvailable and stockReserved",
      "Order states: PENDING, RESERVED, cancelled/expired flows",
      "Idempotency-Key header for safe retries on conflict",
      "E2E test coverage"
    ],
    stack: ["NestJS", "Next.js", "TypeScript", "PostgreSQL", "TypeORM", "JWT"],
    screenshot: "/projects/order management system - ui.png",
    demoCredentials: { user: "invite", password: "rcvSr42Xvm3°" },
    links: [
      { label: "View Demo", href: "https://frontend-virid-nine-82.vercel.app/login?next=%2F", kind: "live" },
      { label: "GitHub", href: "https://github.com/RGabrielR/Order-management-system", kind: "github" }
    ]
  },
  {
    name: "PulseJobs API",
    labels: ["case-study", "arch", "oss"],
    tagline: "Async spreadsheet ingestion backend with job lifecycle, retries, row-level validation and observability.",
    highlights: [
      "Flexible header detection and canonical column mapping",
      "Row-level result persistence with retry history",
      "Structured JSON logs with x-request-id",
      "Cloud Run deployment scripts"
    ],
    stack: ["NestJS", "TypeScript", "PostgreSQL", "Prisma", "JWT", "Cloud Run"],
    screenshot: "/projects/pulsejobs - swagger.png",
    links: [
      { label: "API Docs", href: "https://pulsejobs-api-dlnnihxn5q-uc.a.run.app/api/docs", kind: "live" },
      { label: "GitHub", href: "https://github.com/RGabrielR/pulsejobs-api", kind: "github" }
    ]
  },
  {
    name: "SignalRank",
    labels: ["case-study", "ai", "oss"],
    tagline: "AI-powered news intelligence platform with article ingestion, Gemini-based metadata extraction and discovery APIs.",
    highlights: [
      "Article ingestion with content hashing for deduplication",
      "Gemini-based structured metadata extraction with cache reuse",
      "Ranking and discovery endpoints with filterable outputs",
      "Scale-to-zero Cloud Run deployment"
    ],
    stack: ["NestJS", "Next.js", "TypeScript", "PostgreSQL", "Prisma", "Gemini API"],
    screenshot: "/projects/signalrank - ui.png",
    demoCredentials: { email: "user@test.com", password: "Rt34dd!czV0b" },
    links: [
      { label: "Open Platform", href: "https://signalrank-web.vercel.app/", kind: "live" },
      { label: "GitHub", href: "https://github.com/RGabrielR/signalrank", kind: "github" }
    ]
  }
];

export const enterprise = [
  {
    company: "Enterprise Client",
    initials: "AI",
    role: "AI Systems Engineer",
    impact: "Built AI ingestion system using Google ADK — RAG pipeline with document ingestion, embedding generation and retrieval on GCP. Pub/Sub for async processing, BigQuery for analytics and GCS for document storage.",
    stack: ["Google ADK", "Vertex AI", "Python", "Cloud Run", "Pub/Sub", "BigQuery", "GCS"],
    dates: "2025 – 2026",
    private: true
  },
  {
    company: "Personal Product",
    initials: "HB",
    role: "Backend + AI Engineer",
    impact: "Built hybrid system combining rule-based heuristics and LLM inference for AI-powered chat. Event-driven backend with outbox pattern for reliable delivery and Cloud-Run-hosted scheduled data analysis pipeline.",
    stack: ["NestJS", "TypeScript", "PostgreSQL", "Cloud Run", "Pub/Sub"],
    dates: "2026",
    private: false
  },
  {
    company: "Enterprise Client",
    initials: "GC",
    role: "Cloud Backend Engineer",
    impact: "Built document processing backend using Vertex AI for intelligent extraction and Pinecone for vector similarity search. GCS for document storage, Cloud Run for scalable processing.",
    stack: ["Vertex AI", "Pinecone", "Python", "Cloud Run", "GCS"],
    dates: "2025",
    private: true
  }
];

export const pillars = [
  {
    title: "API & Service Design",
    description: "RESTful backends with clean contracts, DTO validation and modular service boundaries."
  },
  {
    title: "Auth & Access Control",
    description: "JWT flows, role-based guards, secure request handling and request tracing."
  },
  {
    title: "Data Engineering",
    description: "SQL/Prisma modeling, async processing pipelines and job lifecycle management."
  },
  {
    title: "AI / Cloud Systems",
    description: "Vertex AI integrations, RAG pipelines and Cloud Run deployments on GCP."
  },
  {
    title: "Full Stack Delivery",
    description: "React, Next.js, form handling, routing and session-safe auth flows."
  },
  {
    title: "Product Engineering",
    description: "Real products shipped for real users with observability and growth in mind."
  }
];
